import React from 'react';
import '../UploadForm.css';
import Tooltip from '../common/Tooltip.js';
import SvgIcon from '../common/SvgIcon';
import EyeIcon from '../../assets/icons/eye_icon.svg';
import PencilIcon from '../../assets/icons/pencil_icon3.svg';
import CloseIcon from '../../assets/icons/close_icon3.svg';
import FileIconList from '../../assets/icons/file_icon.svg';
import { getInitialTempName } from './filenameUtils';

function UploadedFilesGrid({
  files,
  editedFlags,
  pendingInputs,
  editingIndex,
  tempName,
  setEditingIndex,
  setTempName,
  onEdit,
  onRemove,
  onPreview,
  disabled = false,
}) {
  if (!files || files.length === 0) return null;

  return (
    <div className="uploaded-resume-list">
      <div className="uploaded-files-grid">
        {files.map((file, index) => (
          <Tooltip
            key={index}
            content={editedFlags[index] ? file.name.replace(/\.[^/.]+$/, '') : file.name}
            position="top"
            delay={100}
            verticalOffset={11}
            triggerClassName="uploaded-file-item"
          >
            <div key={index} className={`uploaded-file-item ${disabled ? 'disabled' : ''}`} aria-disabled={disabled}>
              <div
                className="upper-file-icon-wrapper"
                onClick={disabled ? undefined : (e) => {
                  if (!e.target.closest('.remove-file-button, .edit-filename-button')) {
                    onPreview && onPreview(index);
                  }
                }}
              >
                <button
                  className="remove-file-button"
                  onClick={disabled ? undefined : (e) => {
                    e.stopPropagation();
                    onRemove && onRemove(index);
                  }}
                  type="button"
                  disabled={disabled}
                >
                  <SvgIcon
                    src={CloseIcon}
                    color="#ddd"
                    hoverColor="#6e41c1"
                    size="18px"
                    className="exit-icon list"
                  />
                </button>
                <button
                  className="preview-file-button"
                  onClick={disabled ? undefined : (e) => {
                    if (!e.target.closest('.remove-file-button, .edit-filename-button')) {
                      onPreview && onPreview(index);
                    }
                  }}
                  disabled={disabled}
                >
                  <SvgIcon src={EyeIcon} color="#ddd" hoverColor="#6e41c1" size="18px" className="eye-icon-list" />
                </button>
                <div className="file-icon-wrapper">
                  <img src={FileIconList} alt="File icon" className="file-icon-small" />
                </div>
                <p style={{ margin: '1px', fontSize: '0.6em', color: '#888' }}>{'.' + file.name.split('.').pop().toLowerCase()}</p>
              </div>
              <div className="filename-container">
                {editingIndex === index ? (
                  <div className="filename-edit-container">
                    <input
                      type="text"
                      value={tempName}
                      onChange={disabled ? undefined : (e) => setTempName && setTempName(e.target.value)}
                      onBlur={disabled ? undefined : () => onEdit && onEdit(index, tempName)}
                      onKeyDown={disabled ? undefined : (e) => e.key === 'Enter' && onEdit && onEdit(index, tempName)}
                      autoFocus
                      className="filename-edit-input"
                      disabled={disabled}
                    />
                  </div>
                ) : (
                  <div
                    className="filename-display-list"
                    onClick={disabled ? undefined : () => {
                      setEditingIndex && setEditingIndex(index);
                      setTempName && setTempName(getInitialTempName(file.name, !!editedFlags[index]));
                    }}
                  >
                    <span className="filename-text" title={file.name}>
                      {editedFlags[index] ? file.name.replace(/\.[^/.]+$/, '') : file.name}
                    </span>
                    <button
                      onClick={disabled ? undefined : () => {
                        setEditingIndex && setEditingIndex(index);
                        setTempName && setTempName(getInitialTempName(file.name, !!editedFlags[index]));
                      }}
                      className="edit-filename-button"
                      disabled={disabled}
                    >
                      <SvgIcon src={PencilIcon} color="#666" hoverColor="#6e41c1" size="15px" className="pencil-icon" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}

export default UploadedFilesGrid;


